export default "__VITE_ASSET__okLAggYz__"